export default class Config {
    static readonly clientId: string = process.env.REACT_APP_CLIENT_ID!;
    static readonly TenantId: string = process.env.REACT_APP_TENANT_ID!;
    static readonly ApiClientId: string = process.env.REACT_APP_WEB_API_CLIENT_ID!;
    static readonly ApiEndPoint: string = process.env.REACT_APP_API_END_POINT!;
    static readonly SessionsPerDay: number = Number(process.env.REACT_APP_MAX_SESSIONS_PER_DAY!);
    static readonly IntranetKnowledgebases: string = process.env.REACT_APP_INTRANET_KNOWLEDGEBASES_URL!;
    static readonly FinanceKnowledgebases: string = process.env.REACT_APP_FINANCE_KNOWLEDGEBASES_URL!;
}